/**
 * The two feature badges of the v3 redesign (DESIGN-V3). Each label is written only here, so
 * renaming one (Static to "Concept" or "Coming soon", for example) is a one-line change.
 *
 * - Static: a concept shown with sample data from `src/features/<feature>/fixtures.ts`. Its
 *   actions only show the static-preview toast; nothing reaches the API.
 * - New: a real feature on today's API that the legacy panel did not have.
 */
export const STATIC_LABEL = 'Static';
export const NEW_LABEL = 'New';

/** What every action on a static part (Save, Send, Delete, Export) shows instead of working. */
export const STATIC_PREVIEW_MESSAGE = 'This is a static preview.';

/** `false` hides every New badge at once; the new features themselves stay. */
export const SHOW_NEW_BADGES: boolean = true;

export type FeatureKind = 'new' | 'static';

/**
 * Whether static pages, tabs, cards and sections are shown: `VITE_SHOW_STATIC_FEATURES`, read at
 * build time and on by default; `false` gives a clean build without them.
 */
export function showStaticFeatures(): boolean {
  return import.meta.env.VITE_SHOW_STATIC_FEATURES !== 'false';
}

/** Whether a page, tab, card or section marked with this badge is shown. */
export function isFeatureShown(kind: FeatureKind | undefined): boolean {
  return kind !== 'static' || showStaticFeatures();
}

/** The entries (routes, nav items) that only exist while static features are shown. */
export function onlyWithStaticFeatures<T>(entries: readonly T[]): T[] {
  return showStaticFeatures() ? [...entries] : [];
}
